import * as React from 'react'
import { FC } from 'react'
import numeral from 'numeral'
export interface SummaryBoxesProps {
    donorCount: number,
    amount: number,
    campaignCount: number,
}

export const SummaryBoxes: FC<SummaryBoxesProps> = props => {
    const amountDisplay = numeral(props.amount).format('$0.00a')
    const amountTitle = `${numeral(props.amount).format('$0,0.00')}`
    const donorCountDisplay = props.donorCount >= 1000000 ? numeral(props.donorCount).format('0,0.00a') : numeral(props.donorCount).format('0,0')
    const donorCountTitle = `${numeral(props.donorCount).format('0,0')}`

    return (
        <div className="dashboard-summary-boxes">
            <div className="dollars-summary-box summary-box">
                <div className="summary-label dollars">Total Dollars</div>
                <div className="summary-data" title={amountTitle}>{amountDisplay} </div>
            </div>
            <div className="contributions-summary-box summary-box">
                <div className="summary-label"># of Contributions</div>
                <div className="summary-data" title={donorCountTitle}>{donorCountDisplay}</div>
            </div>
            <div className="campaigns-summary-box summary-box">
                <div className="summary-label"># of Campaigns</div>
                <div className="summary-data">{props.campaignCount}</div>
            </div>
        </div>)
}

SummaryBoxes.displayName = 'SummaryBoxes'
